import React, { useEffect, useState } from 'react'
import Container from '../../../components/Container';
import {UserContext} from '../../../UserContext';
import {Grid, ProgressContent, Header, HeaderRelated} from './styled';
import {api} from '../../../services/api';
import Cookies from 'universal-cookie';
import {
    Avatar,
    Button,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Dialog,
    DialogTitle,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography
} from '@material-ui/core';
import {createStyles, makeStyles, Theme, withStyles} from '@material-ui/core/styles';
import {Skeleton} from '@material-ui/lab';
import {useParams} from 'react-router';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import {MdClose} from 'react-icons/md';
import {blue} from '@material-ui/core/colors';
import {IoLogoWhatsapp, IoMdLink} from 'react-icons/io';
import CopyToClipboard from 'react-copy-to-clipboard';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import RoomIcon from '@material-ui/icons/Room';
import {Snackbar} from '@material-ui/core';
import {default as MaterialUiAlert} from '@material-ui/lab/Alert';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import LinearProgress from '@material-ui/core/LinearProgress';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import ShareIcon from '@material-ui/icons/Share';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {useNavigate} from 'react-router';
import { Link } from 'react-router-dom';
import { CsvProducts, Relacionados, RepositoriesProps } from '../../../interfaces';
import Alert from '../../../components/Alert';
import { CSVLink } from 'react-csv';
import DescriptionIcon from '@material-ui/icons/Description';
import JSZipUtils from "jszip-utils"; 
import axios from 'axios';
import { Rowing } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            boxShadow: 'none',
            marginBottom: '20px'
        },
        media: {
            height: 200,
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: '#fff',
            boxShadow: theme.shadows[5],
            width: '100%',
            maxWidth: '500px',
            borderRadius: 7,
            maxHeight: '90vh',
            textAlign: 'center',
            padding: 20
        },
        paperModal: {
            backgroundColor: '#fff',
            boxShadow: theme.shadows[5],
            width: '100%',
            borderRadius: 7,
            maxWidth: 800,
            maxHeight: '90vh',
            textAlign: 'center',
            padding: 20
        },
        exit: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '5px 10px',
        },
        avatar: {
            backgroundColor: blue[100],
            color: blue[600],
        },       
        rootSpeed: {
            height: '100vh',
            width: '100%',
            position: 'fixed',
            top: 0,
            left: 0,
            transform: 'translateZ(0px)',
            flexGrow: 1,
            zIndex: 999,
        },
        speedDial: {
            bottom: theme.spacing(4),
            right: theme.spacing(4),
            position: 'fixed',
        },
    }),    
);

const BorderLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 30,
      borderRadius: 30,
      border: "1px solid #ededed",
      boxShadow: "inset 0px 0px 10px -6px rgba(0,0,0,0.75)"
    },
    colorPrimary: {
        background: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIklEQVQIW2NkQAKrVq36zwjjgzhhYWGMYAEYB8RmROaABADeOQ8CXl/xfgAAAABJRU5ErkJggg==') repeat"
    },
    bar: {
      borderRadius: 5,
      backgroundColor: '#4834d4',
    },
  }),
)(LinearProgress);

export interface SimpleDialogProps {
    open: boolean;
    selectedValue: string;
    onClose: (value: string) => void;
}

const textDefault = 'Clique no link abaixo para visualizar esse produto no Acervo: \n\n';

const whatsApp = (link: string) => {
    window.open('https://api.whatsapp.com/send?text=' + textDefault + link, '_blank');
}

function SimpleDialog(props: SimpleDialogProps) {
    document.title = "Repositório - Sultan Veste a Casa";
    const classes = useStyles();
    const {onClose, selectedValue, open} = props;
    const [openSnack, setSnack] = React.useState(false);

    const handleCloseDialog = () => {
        onClose(selectedValue);
    }

    const handleListItemClick = (value: string) => {
        onClose(value);
        setSnack(true);
    }

    const shareWhatsApp = () => {
        whatsApp(`https://sultan.com.br/acervo/${selectedValue}`);
        handleListItemClick("Copiar Link (Onde Comprar)");
    }

    return (
        <>
            <Dialog onClose={handleCloseDialog} aria-labelledby="simple-dialog-title" open={open}>
                <DialogTitle id="simple-dialog-title">Compartilhar</DialogTitle>
                <List>
                    <ListItem button onClick={shareWhatsApp}
                            key={"No WhatsApp (Acervo)"}>
                        <ListItemAvatar>
                            <Avatar className={classes.avatar}>
                                <IoLogoWhatsapp/>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={"No WhatsApp (Acervo)"}/>
                    </ListItem>
                    <CopyToClipboard text={`https://sultan.com.br/acervo/${selectedValue}`}>
                        <ListItem button onClick={() => handleListItemClick("Copiar Link (Onde Comprar)")}
                                key={"Copiar Link (Onde Comprar)"}>                    
                                <ListItemAvatar>
                                    <Avatar className={classes.avatar}>
                                        <IoMdLink/>
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={"Copiar Link (Onde Comprar)"}/>
                        </ListItem>
                    </CopyToClipboard>
                </List>
            </Dialog>
            <Snackbar open={openSnack} autoHideDuration={3000} onClose={() => setSnack(false)}>
                <MaterialUiAlert severity="success" onClose={() => setSnack(false)}>
                    Operação realizada com sucesso!
                </MaterialUiAlert>
            </Snackbar>
        </>
    );
}

const headers = [
    'CodigoMedida',
    'PKAmbiente',
    'PKAsset',
    'PKCatalogo',
    'PKGrupo',
    'PKLinha',
    'PKMedida',
    'boolAtiva',
    'iAtributosProduto',
    'iQMM',
    'iRepositorio',
    'nA_Embalagem',
    'nA_Produto',
    'nC_Embalagem',
    'nC_Produto',
    'nCubagemEmbalagem',
    'nCubagemUnitaria',
    'nL_Embalagem',
    'nL_Produto',
    'nPesoBruto',
    'nPesoEmbalagem',
    'nQtdeEstoque',
    'nQtdePcasM3',
    'nQtdeSaldoParaVenda',
    'sAmbienteProduto',
    'sClassificacaoFiscal',
    'sCodigo',
    'sDescricao',
    'sDirecaoHierarquia',
    'sDescTipoRepositorio',
    'sDescSituacaoRepositorio',
    'sEAN13',
    'sForaDeLinha',
    'sGrupoProduto',
    'sLinhaProduto',
    'sMedidaProduto',
    'sNomeArquivo',
    'sTabelaAtiva',
    'sTipoEmbalagem',
    'sUnidade1',
];

const Show: React.FC = () => {    
    const [repositories, setRepositories] = React.useState<RepositoriesProps[]>([]);
    const [dataCsv, setDataCsv] = React.useState<CsvProducts[]>([]);
    const [related, setRelated] = React.useState<Relacionados[]>([]);
    const [repository, setRepository] = React.useState<Relacionados[]>([]);
    const {setLoading} = React.useContext(UserContext);
    const [open, setOpen] = React.useState(false);
    const [progress, setProgress] = React.useState<number | null>(null);
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState('');

    const [openDialog, setOpenDialog] = React.useState(false);
    const [openSpeed, setOpenSpeed] = React.useState(false);
    const [image, setImage] = React.useState("");

    const csvLink = React.useRef<any>(null);

    const getRepository = React.useCallback(() => {
        doSearch();
        getCsv();
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        getRepository();
    }, [getRepository]);    

    const classes = useStyles();
    const params = useParams();
    const navigate = useNavigate();

    const cookies = new Cookies();
    const searches = cookies.get('searches');

    const handleOpenImage = (image: string) => {
        setOpen(true);
        setImage(image);
    }

    const handleClose = () => {
        setOpen(false);
    } 
    console.log('aqui eh params',params)
    async function doSearch() {
        try {
            setLoading(true);

            const {data} = await api.get(`/repository/${params.pk}`);
            
            if(searches){
                const searchArray = searches.split('|');
                searchArray.push(params.pk);

                const semRepetidos = searchArray.filter(function(el: string, i: number) {
                    return searchArray.indexOf(el) === i;
                });

                const onlyFive = semRepetidos.reverse().filter((el: string, i : number) => i < 5);

                cookies.set('searches', onlyFive.join("|"), { path: '/' });
            }else{
                cookies.set('searches', params.pk, { path: '/' });
            }

            setRepositories(data.repository);
            setRelated(data.related);
            setRepository(data.repository);
            console.log('aqui é o related',related);
            // console.log('aqui é o repository',repository); 
            
        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        } finally {
            setLoading(false);
        }
    }

    const getCsv = async () => {
        try{
            setLoading(true);

            const {data} = await api.get(`/repository/csv/${params.pk}`);
            setDataCsv(data.infos);
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
        }
    }
    

    const [selectedValue, setSelectedValue] = React.useState("");

    const handleClickOpen = (image: string) => {
        setOpenDialog(true);
        setSelectedValue(image);
    };

    const handleCloseDialog = (value: string) => {
        setOpenDialog(false);
        setSelectedValue(value);
    };

    function urlToPromise(url: any)  : any
    {
        return new Promise(function(resolve, reject) 
        {
            JSZipUtils.getBinaryContent(url, function (err: any, data: any) 
            {
                if(err) 
                {
                    reject(err);
                } else {
                    resolve(data);
                }
            });
        });
        
    }

    const generateZip = async () => {
        try {
            setProgress(0);                 

            var zip = new JSZip();
            zip.file("LEIA-ME.txt", "Obrigado por baixar imagens de nosso repositório!\n");
            const img = zip.folder("images");
    
            if(img === null) return;
                
            repositories.forEach((data) => {
                let name = data.sNomeArquivo;
                img.file(name, urlToPromise(process.env.REACT_APP_HIGH_IMAGE + name), {binary:true});                    
            });
                            
            zip.generateAsync({type:"blob"}, function updateCallback(metadata) {
                setProgress(metadata.percent);
            }).then(function(content) {                    
                saveAs(content, `repositorio-${params.pk}.zip`);
                setSuccess('Arquivos baixados com sucesso!');
            }).catch((e) => {
                setError(e);
            }).finally(() => {
                handleCloseDownload();
            });           
        } catch (error) {
            const result = (error as Error).message;
            setError(result);
        }       
    }

    const downloadImage = async (name: string) => {
        try{
            setLoading(true);
            
            saveAs(process.env.REACT_APP_HIGH_IMAGE + name, name);

            setSuccess('A Imagem foi Baixada!');
        }catch(error){
            const result = (error as Error).message;
            setError(result);
        }finally{
            setLoading(false);
        }
    }

    const handleOpen = () => {        
        setOpenSpeed(true);
    };

    const actions = [        
        { icon: <CloudDownloadIcon style={{fill: "#666"}}/>, name: 'Baixar Imagens', action: handleOpen, operation: 'download'},                
    ];

    if(dataCsv.length > 0){
        actions.push({ icon: <DescriptionIcon style={{fill: "#666"}}/>, name: 'Baixar CSV', action: handleOpen, operation: 'csv'});
    }

    const handleSpeed = (e: React.MouseEvent, operation: string) => {
        e.preventDefault();
        if(operation === "download"){
            generateZip();
        }else if(operation === "csv"){
            if (csvLink && csvLink.current) {
                csvLink.current.link.click();
            }
        }
        handleCloseSpeed();
    }    
    
    const handleCloseSpeed = () => {
        setOpenSpeed(false);
    };

    const handleCloseDownload = () => {
        setProgress(null);
    }

    const handleMessageError = () => {
        setError('');
    }

    const handleMessageSuccess = () => {
        setSuccess('');
    }

    const n = 20;
 
    return (

        <Container>
            <Header className="ds-flex space-between align-items-center">
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={<KeyboardBackspaceIcon />}
                    onClick={() => navigate(-1)}
                >
                    VOLTAR
                </Button>                 
                <h4>Repositório: {params.pk}{repository.slice(0,1).map((row) => <h4> Situação: {row.sDescSituacaoRepositorio}</h4>)}
                {repository.slice(0,1).map((row) => (
                    <h4>Tipo Respositório: {row.sDescTipoRepositorio}</h4>
                ))}
                </h4>
                

            </Header>
            <Grid className="bg-branco">
                {repositories.length > 0 ?
                    repositories.map((el, index) => (
                        <Card key={index} className={classes.root}>
                            <CardActionArea onClick={() => handleOpenImage(el.average_image_url)}>
                                <CardMedia
                                    component={el.file_extension === 'mp4' ? 'iframe' : 'img'}
                                    className={classes.media}
                                    image={el.low_image_url}
                                    title={el.sDescricaoDoc}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="h2">
                                        {el.sDescricaoDoc ? el.sDescricaoDoc : el.sDescricaoTipo === 'Abertura' ? 'Imagem de Abertura' : 'Sem descrição informada.'}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        {el.sDescricaoTipo}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                            <CardActions>
                                {el.filename ?
                                <>
                                    {el.file_extension !== 'mp4' &&
                                        <>
                                            <a target="_blank" title="Onde comprar esse Produto" rel="noreferrer" href={`https://sultan.com.br/sac/${el.filename}`}>
                                                <Button size="small" color="primary">
                                                    <RoomIcon/> ONDE COMPRAR
                                                </Button>
                                            </a>                                
                                            <Button onClick={() => handleClickOpen(el.filename)} size="small" color="primary">
                                                <ShareIcon/> COMPARTILHAR
                                            </Button>
                                            <Button onClick={() => downloadImage(el.sNomeArquivo)} size="small" color="primary">
                                                <CloudDownloadIcon/> BAIXAR
                                            </Button>
                                        </>      
                                    }                                                                  
                                </>
                                :
                                    <p className="bold">Imagem não disponível</p>
                                }                                
                            </CardActions>
                        </Card>
                    ))
                    :
                        [...Array(n)].map((e, i) => (
                            <div key={i}>
                                <Skeleton variant="rect" height={118}/>
                                <Skeleton variant="text"/>
                                <Skeleton variant="text"/>
                            </div>
                        ))                   
                }
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paperModal}>
                            <div className={classes.exit}>
                                <MdClose className="pointer" size={40} onClick={handleClose}/>
                            </div>
                            <img src={image} alt="Imagem do Modal"/>
                        </div>
                    </Fade>
                </Modal>
                <SimpleDialog selectedValue={selectedValue} open={openDialog} onClose={handleCloseDialog}/>
            </Grid>
            <CSVLink 
                headers={headers}
                data={dataCsv} 
                filename={`repositorio-${params.pk}.csv`}
                ref={csvLink}
            >
                
            </CSVLink>
            {related.map((el) => (
                <>   
                    <HeaderRelated>
                        <h3>Repositório: <Link title={`Repositório ${el.iRepositorioRelacionados}`} to={`${process.env.PUBLIC_URL}/usuario/repositorio/${el.iRepositorioRelacionados}`}>{el.iRepositorioRelacionados}</Link>
                         </h3>
                         {repository.slice(0,1).map((row) => (
                    <h3> Situação: {row.sDescSituacaoRepositorio}</h3>
                ))}
                         {repository.slice(0,1).map((row) => (
                    <h3> Tipo Repositório: {row.sDescTipoRepositorio}</h3>
                ))}
                        {related.slice(0,1).map((row) => (
                    <h3>Tipo Relação: {row.sTipoRelacao}</h3>
                ))}
                
                    </HeaderRelated>      
                    <Grid className="bg-branco">
                        {related.length > 0 ?
                            el.items.map((el, index) => (
                                <Card key={index} className={classes.root}>
                                    <CardActionArea onClick={() => handleOpenImage(el.average_image_url)}>
                                        <CardMedia
                                            component={el.file_extension === 'mp4' ? 'video' : 'img'}
                                            className={classes.media}
                                            image={el.low_image_url}
                                            title={el.sDescricaoRepositorio}
                                        />
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                {el.sDescricaoDoc ? el.sDescricaoDoc : el.sDescricaoTipo === 'Abertura' ? 'Imagem de Abertura' : 'Sem descrição informada.'}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary" component="p">
                                                {el.sDescricaoTipo}
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                    <CardActions>
                                        {el.filename ?
                                            <>
                                                <a target="_blank" title="Onde comprar esse Produto" rel="noreferrer" href={`https://sultan.com.br/sac/${el.filename}`}>
                                                    <Button size="small" color="primary">
                                                        <RoomIcon/> ONDE COMPRAR
                                                    </Button>
                                                </a>                                
                                                <Button onClick={() => handleClickOpen(el.filename)} size="small" color="primary">
                                                    <ShareIcon/> COMPARTILHAR
                                                </Button>
                                                <Button onClick={() => downloadImage(el.sNomeArquivo)} size="small" color="primary">
                                                    <CloudDownloadIcon/> BAIXAR
                                                </Button>
                                            </>
                                        :
                                            <p className="bold">Imagem não disponível</p>
                                        }                                
                                    </CardActions>
                                </Card>
                            ))
                            :
                                [...Array(n)].map((e, i) => (
                                    <div key={i}>
                                        <Skeleton variant="rect" height={118}/>
                                        <Skeleton variant="text"/>
                                        <Skeleton variant="text"/>
                                    </div>
                                ))                   
                        }               
                    </Grid>           
                </>
            ))
            }
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={progress !== null}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={progress !== null}>
                    <div className={classes.paper}>                        
                        {progress !== null &&
                            <>
                                <h1>Preparando seu Download</h1>
                                <p>Seu download irá começar assim que a barra abaixo estiver completa.</p>
                                <ProgressContent className="scroll-mac">
                                    <BorderLinearProgress variant="determinate" value={progress}/>
                                </ProgressContent>                            
                            </>
                        }                        
                    </div>
                </Fade>
            </Modal>
            <Backdrop open={openSpeed} className={classes.rootSpeed}/>
            <SpeedDial
                ariaLabel="Opcoes"
                className={classes.speedDial}
                icon={<SpeedDialIcon />}
                onClose={handleCloseSpeed}
                onClick={handleOpen}
                open={openSpeed}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        tooltipOpen
                        onClick={(e) => {
                            handleSpeed(e, action.operation)
                       }}
                    />
                ))}
            </SpeedDial>         
            <Alert open={error !== ''} onClose={handleMessageError} severity="error" message={error}/>                    
            <Alert open={success !== ''} onClose={handleMessageSuccess} severity="success" message={success}/>                    
        </Container>
    )
}

export default Show;
